import { getToken, setToken, removeToken } from '@/utils/auth';
import { getFromCookie, setStateAndCookie } from '@/utils/storage';

const user = {
  namespaced: true,
  state: {
    token: getToken() || '',
    userInfo: getFromCookie('userInfo') || {},
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      setToken(token);
    },
    removeToken(state) {
      state.token = '';
      removeToken();
    },
    saveUserInfo(state, userInfo) {
      setStateAndCookie(state, 'userInfo', userInfo);
    },
  },
};

export default user;
